import axios from "../utils/axios";

export const getEkedEquipments = () => {
    return axios.get(`/EkedEquipment/GetList`);
};

export const addEkedEquipment = (payload) => {
    return axios.post(`/EkedEquipment/Add`, payload);
};

export const updateEkedEquipment = (payload) => {
    return axios.post(`/EkedEquipment/Update`, payload);
};

export const deleteEkedEquipment = (payload) => {
    return axios.delete(`/EkedEquipment/Delete?id=${payload}`);
};

export const getEkedEquipmentFiles = (equipmentId) => {
    return axios.get(`/EkedEquipment/${equipmentId}/Files`, { responseType: "arraybuffer" });
};

export const addEkedEquipmentFiles = (payload) => {
    return axios.post(`/EkedEquipment/${payload.equipmentId}/Files`, payload.data);
};

export const deleteEkedEquipmentFiles = (payload) => {
    return axios.delete(`/EkedEquipment/${payload.equipmentId}/Files`, { data: payload.fileNames });
};

export const getEkedEquipmentFilePreviews = (ekedIds) => {
    return axios.get(`/EkedEquipment/file-previews?ekedIds=${ekedIds}`, { responseType: "arraybuffer" });
};
